import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState() {
  return {};
}

const state = initialState();

// actions

const actions = {
  async get(context, payload) {
    var response = await API.program.get(payload);
    return response;
  },
};

// getters
const getters = {};

// mutations
const mutations = {
    reset(state) {
        // acquire initial state
        const s = initialState ();
        Object.keys (s).forEach (key => {
        state[key] = s[key];
        });
    },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
